import AddressForm from './AddressForm';
import ConnectedAddressForm from './ConnectedAddressForm';

export { AddressForm };
export default ConnectedAddressForm;
